if (!customElements.get('newsletter-validate')) {
  class NewsletterValidate extends HTMLElement {
    constructor() {
      super();

      this.form = this.closest('form');
      if (!this.form) return;

      this.emailInput = this.form.querySelector('.input-email');
      this.errorContainer = this.form.querySelector('.input-error');
      this.errorMessage = this.querySelector('.js-validate-error');
      this.messages = {
        required: this.dataset.msgRequired || 'Email is required',
        invalid: this.dataset.msgInvalid || 'Invalid email',
        noTld: this.dataset.msgNotld || 'Invalid email',
        disposable: this.dataset.msgDisposable || 'Invalid email'
      };

      // Common disposable email domains
      this.disposableDomains = [
        'mailinator.com', 'guerrillamail.com', 'tempmail.com',
        'throwaway.email', 'yopmail.com', 'sharklasers.com',
        'guerrillamailblock.com', 'grr.la', 'dispostable.com',
        'trashmail.com', 'temp-mail.org', 'fakeinbox.com',
        'maildrop.cc', 'discard.email', 'mailnesia.com'
      ];

      this.emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      this.emailInput.addEventListener('input', this.clearError.bind(this));
      this.emailInput.addEventListener('blur', this.handleBlur.bind(this));
    }

    handleSubmit(e) {
      const error = this.validate(this.emailInput.value.trim());
      if (error) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.showError(error);
        this.emailInput.focus();
      }
    }

    handleBlur() {
      const value = this.emailInput.value.trim();
      if (value === '') return;
      const error = this.validate(value);
      if (error) {
        this.showError(error);
      }
    }

    validate(email) {
      // Empty check
      if (!email) return this.messages.required;

      // Basic structure: must have @, domain, and TLD with 2+ chars
      if (!this.emailRegex.test(email)) {
        // Provide a more specific message for missing TLD
        if (/^[^\s@]+@[^\s@]+$/.test(email) && !email.includes('.', email.indexOf('@'))) {
          return this.messages.noTld;
        }
        return this.messages.invalid;
      }

      // Extract parts for further checks
      const [local, domain] = email.split('@');

      // Local part length (RFC 5321)
      if (local.length > 64) return this.messages.invalid;

      // Domain length
      if (domain.length > 253) return this.messages.invalid;

      // No consecutive dots in domain
      if (domain.includes('..')) return this.messages.invalid;

      // Domain labels must not start/end with hyphen
      const labels = domain.split('.');
      for (const label of labels) {
        if (label.startsWith('-') || label.endsWith('-') || label.length === 0) {
          return this.messages.invalid;
        }
      }

      // Disposable email check
      if (this.disposableDomains.includes(domain.toLowerCase())) {
        return this.messages.disposable;
      }

      return null;
    }

    showError(message) {
      if (this.errorMessage) {
        this.errorMessage.textContent = message;
        this.errorMessage.setAttribute('aria-hidden', 'false');
      }
      if (this.errorContainer) {
        this.errorContainer.setAttribute('aria-hidden', 'false');
      }
      this.emailInput.setAttribute('aria-invalid', 'true');
    }

    clearError() {
      if (this.errorMessage) {
        this.errorMessage.setAttribute('aria-hidden', 'true');
      }
      if (this.errorContainer) {
        this.errorContainer.removeAttribute('aria-hidden');
      }
      this.emailInput.removeAttribute('aria-invalid');
    }
  }

  customElements.define('newsletter-validate', NewsletterValidate);
}
